module.exports = __webpack_public_path__ + "img/example_1.df4c7522.png";